<template>
  <div id="service-detail">
    <div class="tab-header">
      <v-row>
        <v-col sm="6">
          <label class="tab-title">{{ $t("SERVICE.INFO") }}</label>
        </v-col>
        <v-col sm="6" class="text-right">
          <button class="btn btn-back mr-5" @click="back">{{ $t("BACK") }}</button>
          <button class="btn btn-save" @click="save">{{ $t("SAVE") }}</button>
        </v-col>
      </v-row>
    </div>
    <div class="tab-content" v-if="editedItem">
      <v-tabs v-model="tab" class="pl-0">
        <v-tab>{{ $t("VIETNAMESE") }}</v-tab>
        <v-tab>{{ $t("ENGLISH") }}</v-tab>
      </v-tabs>
      <v-row v-if="editedItem.i18ns.find(x => x.lang == lang)">
        <v-col sm="8">
          <label class="label-input">{{ $t("SERVICE.NAME") }} *</label>
          <input-text
            :model.sync="editedItem.i18ns.find(x => x.lang == lang).name"
            :error="tab == 0 ? errors.nameVi.error : errors.nameEn.error"
          />
          <p v-if="required_name && editedItem.i18ns.find(x => x.lang == lang).name == ''" class="mt-2 text-danger">
            {{ $t("SERVICE.NAME") }} {{ $t("SERVICE.NOT_EMPTY") }}
          </p>
          <label class="label-input mt-3">{{ $t("SERVICE.DESCRIPTION_INFO") }}</label>
          <input-textarea
            :rows="3"
            :model.sync="editedItem.i18ns.find(x => x.lang == lang).description"
          />

          <label class="label-input mt-3">{{ $t("SERVICE.CODE") }} *</label>
          <input-text
            :model.sync="editedItem.code" @change.native="checkServiceCodeExit" :regex="REGEX_SERVICE_CODE" class="service-code" maxlength="20" :disabled=" editedItem.id ? true : false"
          />
          <p v-if="required_code_length" class="mt-2 text-danger">
            {{ $t("SERVICE.CODE") }} {{ $t("SERVICE.CODE_MAX_LENGTH") }}
          </p>
          <p v-if="isServiceCodeExit" class="mt-2 text-danger">
            {{ $t("SERVICE.CODE") }} {{ $t("SERVICE.HAS_EXITS") }}
          </p>
          <v-checkbox
            v-model="editedItem.active"
            :label="$t('ACTIVE')"
          ></v-checkbox>
        </v-col>
        <v-col sm="4">
           <p class="pl-3 m-0">{{$t('IMAGE_SERVICE')}} *</p>
          <div class="d-flex">
            <div
              class="square"
              @mouseover="changeImageOverlay(true)"
              @mouseleave="changeImageOverlay(false)"
            >
              <img
                v-if="!imagePreview"
                src="@/assets/no-image.jpg"
                class="square-content p-3"
              />
              <v-img v-if="imagePreview" :src="imagePreview" class="square-content" />
              <v-overlay :absolute="true" :value="showImageOverlay"> 
                <div class="d-flex">
                  <label class="d-flex justify-center btn-icon label-upload" for="input-file">
                    <v-icon color="#173d8f">mdi-upload</v-icon>
                  </label>
                  <input
                    class="d-none"
                    style="display: none"
                    type="file"
                    :value="fileUpload"
                    @change="changeImage($event)"
                    accept="image/*"
                    id="input-file"
                  />
                </div>
              </v-overlay>
            </div>
          </div>
          <p v-if="isNoThumb" class="text-danger">{{ $t("SERVICE.NOTHUMB") }}</p>
          <p v-if="isImageLarge" class="text-danger">{{ $t("SERVICE.IMAGE_TOO_LARGE") }}</p>
        </v-col>
      </v-row>
      <v-divider />
      <p class="mt-2">{{ $t("SERVICE.TIME_APPLY") }}</p>

      <!-- Thoi gian ap dung -->
      <v-row>
        <v-col cols="3">
          <p class="mt-2">{{ $t("SERVICE.DAY_APPLY") }}</p>
        </v-col>
        <v-col cols="9">
          <multiSelect :options="dayApplyInWeekOptions" :model.sync="dayApplyInWeekSelected"/>
        </v-col>
      </v-row>

      <!-- Thoi gian dat -->
      <v-row>
        <v-col cols="3">
          <p class="mt-4">{{ $t("SERVICE.TIME_BOOK") }}</p>
        </v-col>
        <v-col cols="3">
          <v-radio-group row v-model="timeBookType" class="mt-0">
            <v-radio class="pt-2" color="indigo darken-3" :label="$t('ALWAYS')" :value="0"></v-radio>
            <v-radio class="pt-2" color="indigo darken-3" :label="$t('IN_PERIOD')" :value="1"></v-radio>
          </v-radio-group>
        </v-col>
        <v-col cols="6">
            <v-row>
              <v-col sm="6" class="pt-0 pb-0">
                <date-picker
                  :model.sync="editedItem.fromBook"
                  :min="currentDate"
                  :disabled="!timeBookType"
                />
                <p v-if="errorfromBook && timeBookType" class="text-danger">
                  {{ $t("SERVICE.NOT_EMPTY") }}
                </p>
              </v-col>
              <v-col sm="6" class="pt-0 pb-0">
                <date-picker
                  :model.sync="editedItem.toBook"
                  :min="editedItem.fromBook"
                  :disabled="!timeBookType"
                />
                <p v-if="errortoBook && timeBookType" class="text-danger">
                  {{ $t("SERVICE.NOT_EMPTY") }}
                </p>
              </v-col>
            </v-row>
        </v-col>
      </v-row>

      <!-- Thoi gian su dung -->
      <v-row>
        <v-col cols="3">
          <p class="mt-4">{{ $t("SERVICE.TIME_USE") }}</p>
        </v-col>
        <v-col cols="3">
          <v-radio-group row v-model="timeUseType" class="mt-0">
            <v-radio class="pt-2" color="indigo darken-3" :label="$t('ALWAYS')" :value="0"></v-radio>
            <v-radio class="pt-2" color="indigo darken-3" :label="$t('IN_PERIOD')" :value="1"></v-radio>
          </v-radio-group>
        </v-col>
        <v-col cols="6">
            <v-row>
              <v-col sm="6" class="pt-0 pb-0">
                <date-picker
                  :model.sync="editedItem.fromStaying"
                  :min="currentDate"
                  :disabled="!timeUseType"
                />
                <p v-if="errorfromStaying && timeUseType" class="text-danger">
                  {{ $t("SERVICE.NOT_EMPTY") }}
                </p>
              </v-col>
              <v-col sm="6" class="pt-0 pb-0">
                <date-picker
                  :model.sync="editedItem.toStaying"
                  :min="editedItem.fromStaying"
                  :disabled="!timeUseType"
                />
                <p v-if="errortoStaying && timeUseType" class="text-danger">
                  {{ $t("SERVICE.NOT_EMPTY") }}
                </p>
              </v-col>
            </v-row>
        </v-col>
      </v-row>

      <!-- Ngay khong ap dung -->
      <div class="v-row">
        <p>{{ $t("SERVICE.DAYS_NOT_APPLY") }}</p>
        <v-row class="day-not-applied">
          <v-col sm="4" class="py-0" v-for="(date, i) in notApplyDates" :key="i">
            <v-flex class="d-flex">
              <date-range-picker
                v-model="notApplyDates[i]"
                class="mt-2"
                :autoApply="true"
                opens="left"
                :ranges="false"
                @update="updateDate"
                :min-date="yesterday"
              >
                <template v-slot:input="picker" style="min-width: 350px;">
                    {{ picker.startDate | moment }} -> {{ picker.endDate | moment }} 
                </template>
              </date-range-picker>
         
              <v-icon color="indigo" @click="removeDate(i)">delete</v-icon>
            </v-flex>
          </v-col>
        </v-row>
        <button class="add-not-apply-date mt-3" @click="addnotApplyDates">
          <v-icon color="#173d8f" >add</v-icon>
          {{ $t("SERVICE.ADD_DAYS_NOT_APPLY") }}
        </button>
      </div>

      <!-- Dich vu mien phi -->
      <v-radio-group row v-model="editedItem.free" class="" @change="selectFreeService">
        <v-radio color="indigo darken-3" :label="$t('SERVICE.FREE')" :value="true" ></v-radio>
        <v-radio color="indigo darken-3" :label="$t('SERVICE.PREMIUM')" :value="false"></v-radio>
      </v-radio-group>

      <!-- Gia bao gom thue hay chua -->
      <v-row class="include-tax">
        <v-col>
        <div class="label-price">{{ $t("SERVICE.PRICE") }} *: </div>
        <v-checkbox
          v-model="editedItem.includedTax"
          :label="$t('SERVICE.INCLUDE_TAX')"
          :classList="input-include-tax"
        ></v-checkbox>
        </v-col>
        <v-col>
          <span>{{ $t("SERVICE.CURRENCY") }} : {{ currencyCode }}</span>
        </v-col>
      </v-row>
  
      <!-- Gia theo ngay --> 
      <table v-if="!editedItem.free">
        <thead>
          <th>
            <div class="header-wrapper vertical-divider text-center">
                <span class="text-center">{{ $t("SERVICE.COPPY") }}</span>
              </div>
          </th>
          <template v-for="item in daysOfWeek">
            <th :key="item.code">
              <div class="header-wrapper vertical-divider text-center">
                <span class="text-center">{{ item.value }}</span>
              </div>
            </th>
          </template>
        </thead>
        <tbody>
          <tr>
            <td align="center">
                <span class="icon icon-notifications-ic-copy-3 btn-multi-copy" @click="copyFirstValue(editedItem['priceSunday'])" ></span>
            </td>
            <template v-for="(date, index) in daysOfWeek">
              <td :key="date.code">
                <div class="price-day">
                  <vue-numeric v-if="!checkValidDay(index)" :separator="sysLang == 'vi' ? '.' : ','" v-model="editedItem[date.code]" class="form-control text-right" disabled="disabled" ></vue-numeric>
                  <vue-numeric v-else :separator="sysLang == 'vi' ? '.' : ','" v-model="editedItem[date.code]" class="form-control text-right"></vue-numeric>
                </div>
              </td>
            </template>
          </tr>
        </tbody>
      </table>

      <!-- Gia dac biet -->
      <div class="mt-5">
        <b-button v-b-modal.popup-special-days-price class="btn btn-popup-special-days-price"><v-icon v-if="specialDaysPrice.length === 0" color="#173d8f" >add</v-icon> {{ $t(specialDaysPrice.length === 0 ? "SERVICE.SPECIAL_PRICE" : "SERVICE.DETAIL_SPECIAL_PRICE") }}</b-button>
        <b-modal ref="popup-special-days-price" id="popup-special-days-price" size="lg" centered no-close-on-backdrop no-close-on-esc :title="$t('SERVICE.SPECIAL_PRICE')">
          <div class="table-special-days-price">
            <v-row class="text-center header-special-days-price">
              <v-col sm="6">{{ $t("SERVICE.SPECIAL_PRICE_TITLE") }}</v-col>
              <v-col sm="6">{{ $t("SERVICE.SPECIAL_PRICE_VALUE") }}</v-col>
            </v-row>
            <v-row class="special-price">
              <v-col sm="12" class="py-0" v-for="(item, i) in specialDaysPrice" :key="i">
                <v-flex class="d-flex">
                  <v-row class="mt-2">
                    <v-col sm="6" class="pt-0 pb-0">
                      <date-range-picker
                        v-model="specialDaysPrice[i].date"
                        :autoApply="true"
                        opens="right"
                        :ranges="false"
                        :min-date="yesterday"
                      >
                        <template v-slot:input="picker" style="width: 100%;">
                            {{ picker.startDate | moment }} -> {{ picker.endDate | moment }} 
                        </template>
                      </date-range-picker>
                    </v-col>
                    <v-col sm="6" class="pt-0 pb-0">
                      <vue-numeric :separator="sysLang == 'vi' ? '.' : ','" v-model="item.price" class="" :class="item.price == null && item.error_price == true ? 'form-control text-right border-error input-price': 'form-control text-right input-price' "></vue-numeric>

                      <p v-if="item.price == null && item.error_price == true" class="mt-1 text-danger"> {{ $t("SERVICE.SPECIAL_PRICE_VALUE") }} {{ $t("SERVICE.NOT_EMPTY") }} </p>
                    </v-col>
                  </v-row>
                  <v-icon color="indigo" @click="removeSpecialDayPrice(i)">delete</v-icon>
                </v-flex>
              </v-col>
              <v-col>
                <p v-if="errorApiSpecialService" class="mt-1 text-danger">{{ $t("SERVICE.ERROR_DUPLICATE_DAY") }}</p>
              </v-col>
            </v-row>
            <button class="btn add-special-price mt-3" @click="addSpecialDaysPrice">
              <v-icon color="#173d8f" >add</v-icon>
              {{ $t("SERVICE.ADD_SPECIAL_PRICE") }}
            </button>
          </div>
          <template v-slot:modal-footer>
            <div class="w-100">
              <b-button
                variant="primary"
                size="sm"
                class="float-right save"
                @click="saveSpecialDaysPrice()"
              >
                {{ $t("SAVE") }}
              </b-button>
              <b-button
                variant="secondary"
                size="sm"
                class="float-right cancel mr-2"
                @click="cancelSpecialDaysPrice()"
              >
                {{ $t("SERVICE.CANCEL") }}
              </b-button>
            </div>
          </template>
        </b-modal>
        <span class="special-service-desc">* {{ $t(specialDaysPrice.length === 0 ? "SERVICE.SPECIAL_DESC" : "SERVICE.DECLARED_SPECIAL_DAY_PRICE") }}</span>
      </div>
      
      <!-- Don vi tinh -->
      <v-row class="mt-3">
        <v-col sm="6">
          <p class="mb-1">{{ $t("SERVICE.UNIT") }} *</p>
          <select-text
            class="pr-2"
            style="flex: 1"
            :items="unitOptions"
            :id.sync="editedItem.serviceType"
          />
        </v-col>
        <v-col sm="6">
          <p class="mb-1">{{ $t("SERVICE.TAX_LABEL") }} *</p>
          <multiSelect :options="taxOptions" :model.sync="taxSelected" class="disable-select-tax"/>
        </v-col>
        <v-col sm="6">
          <p class="mb-1">{{ $t("SERVICE.MAXBOOK") }}</p>
          <input-text
            :notSmallThan="0"
            :isMoney="false"
            :regex="REGEX_NUMBER"
            :model.sync="editedItem.maxOrder"
          />
        </v-col>
      </v-row>
      <v-divider />

      <!-- Goi ban ap dung -->
      <label class="label-input font-weight-black">{{ $t("SERVICE.PACKAGE_SELL") }}</label>
      <v-radio-group v-model="editedItem.applyAllPlan" class="mt-0">
        <v-radio color="indigo darken-3" :label="$t('SERVICE.PACKAGE_ALL')" :value="'ALL'"></v-radio>
        <v-radio color="indigo darken-3" :label="$t('SERVICE.PACKAGE_SPEC')" :value="'NOT_ALL'"></v-radio>
      </v-radio-group>
      <v-row v-if="listOfRooms && editedItem.applyAllPlan !== 'ALL'" class="room-list mb-5">
        <v-col md="6" class="child-no-margin py-0">
          <v-checkbox
            color="indigo darken-3"
            :label="$t('SELECT_ALL')"
            @change="clickSelectAllPlans"
            v-model="selectAllPlans"
          />
        </v-col>
        <v-col
          md="6"
          class="child-no-margin py-0"
          v-if="room.i18ns && room.i18ns.find(x => x.lang == sysLang)"
          v-for="room in listOfRooms"
          :key="room.id"
        >
          <v-checkbox
            color="indigo darken-3"
            :label="room.i18ns.find(x => x.lang == sysLang).name + ' - ' + room.id"
            :value="room.id"
            :error="errors.roomsApply.error"
            v-model="editedItem.plans"
            @change="editedItem.plans.length == listOfRooms.length ? selectAllPlans = true : selectAllPlans = false"
          />
        </v-col>
      </v-row>

      <!-- Kenh ban ap dung -->
      <label class="label-input mt-3 font-weight-black">{{ $t("SERVICE.SELL_CHANEL") }}</label>
      <v-radio-group v-model="editedItem.applyAllChannel" class="mt-0">
        <v-radio color="indigo darken-3" :label="$t('SERVICE.CHANEL_ALL')" :value="'ALL'"></v-radio>
        <v-radio color="indigo darken-3" :label="$t('SERVICE.CHANEL_SPEC')" :value="'NOT_ALL'"></v-radio>
      </v-radio-group>
      <v-row v-if="listOfChannels && editedItem.applyAllChannel !== 'ALL'" class="room-list mb-5">
        <v-col
          md="6"
          class="child-no-margin py-0"
          v-for="channel in listOfChannels"
        >
          <v-checkbox
            color="indigo darken-3"
            :label="channel.name"
            :value="channel.id"
            v-model="editedItem.channels"
          />
        </v-col>
      </v-row>
    </div>
    <delete-dialog @deleteItem="deleteImage" :maxWidth="325" ref="deleteimage">
      <v-card-title slot="title" class="headline p-0">{{ $t("CONFIRM_DELETE_PROMOTION_PACKAGE") }}?</v-card-title>
    </delete-dialog>
    <!-- {{ editedItem }} -->
  </div>
</template>

<script>
import DatePicker from "@/components/Utils/DatePicker.vue";
import MultiSelect from "@/components/Utils/MultiSelect.vue";
import { VueEditor } from "vue2-editor";
//import Multiselect from "vue-multiselect";
import Input from "@/components/Utils/Input.vue";
import Select from "@/components/Utils/Select.vue";
import { salePackageService } from "@/_services/SaleRoom/sale-package.service.js";
import { servicePackageService } from "@/_services/Service/service.service.js";
import DeleteDialog from "@/components/Utils/DeleteDialog.vue";
import moment, { max } from "moment";
import VueNumeric from 'vue-numeric'

import DateRangePicker from 'vue2-daterange-picker';
//you need to import the CSS manually (in case you want to override it)
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';



import {
  _validateFormI18n,
  _alert,
  _formatCurrency,
  _resetErrorState
} from "@/_helpers/function.js";
import { REGEX_NUMBER } from "@/_helpers/constant.js";
import { REGEX_SERVICE_CODE } from "@/_helpers/constant.js";
import {
  MAX_CHILD_QUANTITY,
  MAX_ADULTS_QUANTITY,
  MEALS,
  SPD_ERROR
} from "@/_helpers/config.js";
import Textarea from "@/components/Utils/Textarea.vue";
export default {
  components: {
    //Multiselect,
    "date-picker": DatePicker,
    "input-text": Input,
    "select-text": Select,
    multiSelect: MultiSelect,
    VueEditor,
    "input-textarea": Textarea,
    "delete-dialog": DeleteDialog,
    DateRangePicker,
    VueNumeric
  },
  created() {
    this.initialize();
  },
  data() {
    return {
      required_name: false,
      required_code: false,
      required_code_length: false,
      required_code_exits: false,
      currentDate: moment(new Date()).format("YYYY-MM-DD"),
      editedItem: [],
      dayApplyInWeekSelected: [ 1, 2, 3, 4, 5, 6, 7 ],
      dayApplyInWeekOptions: [
        { id: 1,  value : 1, text: `${this.$t("SUNDAY")}` },
        { id: 2,  value : 2, text: `${this.$t("MONDAY")}` },
        { id: 3,  value : 3, text: `${this.$t("TUESDAY")}` },
        { id: 4,  value : 4, text: `${this.$t("WEDNESDAY")}` },
        { id: 5,  value : 5, text: `${this.$t("THURSDAY")}` },
        { id: 6,  value : 6, text: `${this.$t("FRIDAY")}` },
        { id: 7,  value : 7, text: `${this.$t("SATURDAY")}` }
      ],
      taxSelected: [1],
      taxOptions: [
        { id: 1,  value : 1, text: `${this.$t("SERVICE.TAX_DEFAULT")}` },
      ],
      timeBookType: 0,
      timeUseType: 0,
      unitOptions: [
        { id: 'PER_BOOKING', value: `${this.$t("SERVICE.PER_BOOKING")}` },
        { id: 'PER_PERSON_PER_NIGHT', value: `${this.$t("SERVICE.PER_PERSON_PER_NIGHT")}` },
        { id: 'PER_ROOM', value: `${this.$t("SERVICE.PER_ROOM")}` },
        { id: 'PER_ROOM_PER_NIGHT', value: `${this.$t("SERVICE.PER_ROOM_PER_NIGHT")}` },
        { id: 'PER_PERSON', value: `${this.$t("SERVICE.PER_PERSON")}` },
      ],
      // tmp: null,
      listOfRooms: [],
      listOfChannels: [
        { id: 1, name: 'Booking Engine'},
        { id: 2, name: 'OneInventory'},
      ],
      daysOfWeek: [
        { code: "priceSunday", value: this.$t("SUNDAY") },
        { code: "priceMonday", value: this.$t("MONDAY") },
        { code: "priceTuesday", value: this.$t("TUESDAY") },
        { code: "priceWednesday", value: this.$t("WEDNESDAY") },
        { code: "priceThursday", value: this.$t("THURSDAY") },
        { code: "priceFriday", value: this.$t("FRIDAY") },
        { code: "priceSaturday", value: this.$t("SATURDAY") },
      ],
      showImageOverlay: false,
      fileUpload: '',
      imagePreview: '',
      isNoThumb: false,
      currencyCode: JSON.parse(localStorage.getItem("currentUser")).hotel
        .currency
        ? JSON.parse(localStorage.getItem("currentUser")).hotel.currency.code ||
          "VND"
        : "VND",
      tab: null,
      sysLang: this.$i18n.locale,
      lang: "vi",
      isServiceCodeExit: false,
      notApplyDates: [],
      specialDaysPrice: [],
      selectAllPlans: false,
      imageFormData: '',
      errors: SPD_ERROR,
      dialog: false,
      originalSpecialDaysPrice: [],
      errorApiSpecialService: false,
      errorfromBook: false,
      errortoBook: false,
      errorfromStaying: false,
      errortoStaying: false,
      errorname_vi: false,
      errorname_en: false,
      isImageLarge: false,
    };
  },
  computed: {
    yesterday() {
      var d = new Date();
      return d.setDate(d.getDate() - 1);

    },
    REGEX_NUMBER() {
      return REGEX_NUMBER;
    },
    REGEX_SERVICE_CODE() {
      return REGEX_SERVICE_CODE;
    }
  },
  watch: {
    tab(value) {
      this.lang = value ? "en" : "vi";
    },
    lang(value) {
      this.editorData = this.editedItem.i18ns.find(
        x => x.lang == value
      ).description;
    },
    dayApplyInWeekSelected() {
      let tmp_applyDay = [0,0,0,0,0,0,0];
      this.dayApplyInWeekSelected.forEach(function(value) {
        tmp_applyDay[value-1] = 1;
      });
      this.editedItem.applyDay = tmp_applyDay.toString().replace(/,/g, ''); 
      // this.daysOfWeek.forEach((element, index) => {
      //   if (this.editedItem.applyDay.charAt(index) === '0'){
      //     this.editedItem[element.code] = 0;
      //   }
      // });
    },
    timeBookType() {
      if ( this.timeBookType == 0 ) {
        this.editedItem.fromBook = null;
        this.editedItem.toBook = null;
        // alert('dsfs');
      } else {

      }
    },
    timeUseType() {
      if ( this.timeUseType == 0 ) {
        this.editedItem.fromStaying = null;
        this.editedItem.toStaying = null;
        // alert('dsfs');
      } else {

      }
    }
  },
  mounted() {
    document
      .querySelector(".v-tab.v-tab--active")
      .classList.remove("v-tab--active");
    document
      .querySelector(".v-tab[tabIndex='0']")
      .classList.add("v-tab--active");
  },
  methods: {
    async initialize() {

      _resetErrorState(this.errors);
      let id = parseFloat(this.$route.params.id);
      
      if (id) {
        servicePackageService.getDetailService(id).then(res => {
          this.editedItem = res.data;
          this.imagePreview = this.editedItem.image;

          // if ( this.editedItem.image || this.editedItem.imgId ) {
          //   this.isNoThumb = 
          // }

          // Chuyen mang applyDay sang mang dung cho multiselect
          let tmp_dayApplyInWeekSelected= [];
          res.data.applyDay.split("").forEach(function(value, index){
            if (value === "1") {
              let tmp_day = parseInt(index) + 1;
              tmp_dayApplyInWeekSelected.push(tmp_day);
            }
          });

          // Neu ton tai khoang thoi gian su dung
          if ( this.editedItem.fromStaying && this.editedItem.toStaying ) {
            this.timeUseType = 1;
            this.editedItem.fromStaying = moment(this.editedItem.fromStaying ).format("YYYY-MM-DD");
            this.editedItem.toStaying = moment(this.editedItem.toStaying ).format("YYYY-MM-DD");
          }

          // Neu ton tai khoang thoi gian dat
          if ( this.editedItem.fromBook && this.editedItem.toBook ) {
            this.timeBookType = 1;
            this.editedItem.fromBook = moment(this.editedItem.fromBook ).format("YYYY-MM-DD");
            this.editedItem.toBook = moment(this.editedItem.toBook ).format("YYYY-MM-DD");
          }

          this.dayApplyInWeekSelected = tmp_dayApplyInWeekSelected;
          
          // Chuyen notApplyDates tu unix sang date time
          this.editedItem.notApplyDates.forEach(x => {
            let date_from = new Date(x.from);
            let date_to = new Date(x.to);
            this.notApplyDates.push({ startDate: moment(date_from).format("YYYY-MM-DD"), endDate: moment(date_to).format("YYYY-MM-DD") });
          });

          this.editedItem.specials.forEach(x => {
            let date_from = new Date(x.startDate);
            let date_to = new Date(x.endDate);

            // let appliedDate = new Date(x.appliedDate);
            this.originalSpecialDaysPrice.push({ date: { startDate: date_from, endDate: date_to }, price: x.price, error_time: false, error_price: false });
            this.specialDaysPrice.push({ date: { startDate: date_from, endDate: date_to }, price: x.price, error_time: false, error_price: false});
          });
          
        });
      } else {
        this.editedItem = {
          active: true,
          applyAllChannel: 'ALL',
          applyAllPlan: 'ALL',
          applyDay: "1111111",
          channels: [],
          code: '',
          free: false,
          fromBook: null,
          fromStaying: null,
          imgId: '',
          includedTax: true,
          maxOrder: 1,
          notApplyDates: [],
          plans: [],
          priceFriday: '',
          priceMonday: '',
          priceSaturday: '',
          priceSunday: '',
          priceThursday: '',
          priceTuesday: '',
          priceWednesday: '',
          serviceType: 'PER_ROOM',
          specials: [],
          toBook: null,
          toStaying: null,
          i18ns: [
            { description: "", lang: "vi", name: "" },
            { description: "", lang: "en", name: "" }
          ],
        };
      }
      
      // Dong bo tich chon cac phong
      this.roomTyleApplied =  this.editedItem.plans;
      salePackageService.get().then(res => {
        if (res.responseCode == 0) {
          this.listOfRooms = res.data.map(x => {
            return {
              id: x.id,
              i18ns: x.i18ns,
            };
          });
          this.roomTyleApplied = this.roomTyleApplied.filter(x =>
            this.listOfRooms.map(x => x.id).includes(x)
          );
        }
      });
    },
    checkServiceCodeExit(){
      if ( this.editedItem.code.length < 3 ) {
        this.required_code_length = true;
      } else {
        this.required_code_length = false;
        servicePackageService.checkServiceCode(this.editedItem.code).then(res => {
          if(res.responseCode == 1) {
            this.isServiceCodeExit = true;
            this.required_code_exits = true;
          }else {
            this.isServiceCodeExit = false;
            this.required_code_exits = false;
          }
        });
      }
    },
    async save() {
      this.required_name = false;
      // this.required_code = false;
      let element = document.querySelector(".btn-save");
      this.editedItem.i18ns.forEach(e => {
        if ( e.name == "" ) {
          this.required_name = true;
          if (e.lang == 'vi') {
            this.errorname_vi = true;
          } else if( e.lang == 'en') {
            this.errorname_en = true;
          }
        } else {
          this.errorname_en = false;
          this.errorname_vi = false;
        }
      });
      if ( !this.errorname_vi && this.errorname_en ) {
        this.tab = 1;
      } else {
        this.tab = 0;
      }
      if ( this.editedItem.code.length < 3 ) {
        this.required_code_length = true;
      }

      if ( this.editedItem.fromBook == null && this.timeBookType == 1 ) {
        this.errorfromBook = true;
      } else {
        this.errorfromBook = false;
      }

      if ( this.editedItem.toBook == null && this.timeBookType == 1 ) {
        this.errortoBook = true;
      } else {
        this.errortoBook = false;
      }

      if ( this.editedItem.fromStaying == null && this.timeUseType == 1 ) {
        this.errorfromStaying= true;
      } else {
        this.errorfromStaying= false;
      }

      if ( this.editedItem.toStaying == null && this.timeUseType == 1 ) {
        this.errortoStaying = true;
      } else {
        this.errortoStaying = false;
      }

      if ( !this.editedItem.image || !this.editedItem.imgId) {
        this.isNoThumb = true;
      }

      if ( !this.isNoThumb && !this.required_name && !this.required_code_exits && !this.required_code_length && !this.errortoStaying  && !this.errorfromStaying && !this.errorfromBook && !this.errortoBook) {
        this.isImageLarge = false;
        if (this.editedItem.id) {
          let tmp = Object.assign({}, this.editedItem);
          delete tmp.image;

          await servicePackageService.updateService(tmp).then(res => {
            _alert(res, this.$t(res.data), false );
            if (res.responseCode != 0) {
              element.disabled = false;
            }
          });
        } else {
          let tmp = Object.assign({}, this.editedItem);
          delete tmp.image;
          await servicePackageService.createService(tmp).then(res => {
            _alert(res, this.$t(res.data), false );
            this.$router.back();
            if (res.responseCode != 0) {
              element.disabled = false;
            }
          });
        }
      }
    },
    selectFreeService() {
        if ( this.editedItem.free) {
        this.daysOfWeek.forEach(e=>{
          this.editedItem[e.code] = 0;
        });
      }
    },
    checkValidDay(index){
      // alert(this.editedItem.applyDay.charAt(index));
      // // console.log( this.editedItem.applyDay.charAt(index) );
      if (this.editedItem.applyDay.charAt(index) === '1'){
        return true;
      } else {
        return false;
      }
      // return this.editedItem.applyDay.charAt(index);
    },
    back() {
      this.$router.back();
    },
    addnotApplyDates() {
      if(this.notApplyDates.length === 0){
        this.notApplyDates.push({
            startDate: this.currentDate,
            endDate: new Date( moment(this.currentDate).add(1, 'd')) 
          }
        );
      } else {
         this.notApplyDates.push({
            startDate: new Date( moment(this.notApplyDates[this.notApplyDates.length - 1].endDate).add(1, 'd')) ,
            endDate: new Date( moment(this.notApplyDates[this.notApplyDates.length - 1].endDate).add(2, 'd')) 
          }
        );
      }
      this.updateDate();
    },
    updateDate() {
      this.editedItem.notApplyDates = [];
      this.notApplyDates.forEach(e=>{
        this.editedItem.notApplyDates.push(
          {
            from: moment(e.startDate).format("YYYY-MM-DD"),
            to:  moment(e.endDate).format("YYYY-MM-DD")
          }
        )
      });
    },
    removeDate(index) {
      this.notApplyDates.splice(index, 1);
      this.updateDate();
    },
    addSpecialDaysPrice() {
      if(this.specialDaysPrice.length === 0){
          this.specialDaysPrice.push({
            date : {
              startDate: this.currentDate,
              endDate: new Date( moment(this.currentDate).add(1, 'd')),
            },
            price: null,
            error_time: false,
            error_price: false,
          });
      } else {
         this.specialDaysPrice.push({
            date: {
              startDate: new Date( moment(this.specialDaysPrice[this.specialDaysPrice.length - 1].date.endDate).add(1, 'd')) ,
              endDate: new Date( moment(this.specialDaysPrice[this.specialDaysPrice.length - 1].date.endDate).add(2, 'd')),
            },
            price: null,
            error_time: false,
            error_price: false,
          }
        );
      }
    },
    saveSpecialDaysPrice(){
      let error = false;
      this.specialDaysPrice.forEach((item, index ) => {
        if (item.price == null){
          this.specialDaysPrice[index].error_price = true ;
          error = true;
        }
        if (item.date.startDate == null || item.date.endDate == null){
          this.specialDaysPrice[index].error_time = true ;
          error = true;
        }
      });

      if ( !error ) {
        let tmp_array = [];
        this.specialDaysPrice.forEach(e=>{
          tmp_array.push({
            startDate: moment(e.date.startDate).format("YYYY-MM-DD"),
            endDate: moment(e.date.endDate).format("YYYY-MM-DD"),
            price: e.price
          });
        });
          servicePackageService.checkSpecialDaysPrice(tmp_array).then(res => {
          if (res.responseCode == 0) {
            this.editedItem.specials = tmp_array;
            this.$refs['popup-special-days-price'].hide();
            this.errorApiSpecialService = false;
          } else { 
            this.errorApiSpecialService = true;
          }
        });
      }
    },
    cancelSpecialDaysPrice(){
      let tmp_array = [];
      this.specialDaysPrice = [];
      this.originalSpecialDaysPrice.forEach(e=>{
        tmp_array.push({
          startDate: moment(e.date.startDate).format("YYYY-MM-DD"),
          endDate: moment(e.date.endDate).format("YYYY-MM-DD"),
          price: e.price
        });
        this.specialDaysPrice.push({
          date: { 
            startDate: e.date.startDate, 
            endDate: e.date.endDate 
          },
          price: e.price, error_time: false, error_price: false
        });
      });
      // // console.log( this.originalSpecialDaysPrice );
      // let tmp = Object.assign({}, this.editedItem);
      // this.specialDaysPrice = Object.assign({}, this.originalSpecialDaysPrice );

      this.editedItem.specials = tmp_array;
      this.$refs['popup-special-days-price'].hide();
      this.errorApiSpecialService = false;
    },
    removeSpecialDayPrice(index) {
      this.specialDaysPrice.splice(index, 1);
    },
    _formatCurrency: _formatCurrency,
    changeImageOverlay(visible) {
      this.showImageOverlay = visible;
    },
    changeImage(input){
      const formData = new FormData();
      formData.append('file', input.target.files[0]);
      // console.log( input.target );
      // this.imagePreview = URL.createObjectURL(input.target.files[0]);

      this.imageFormData = formData;
      if ( input.target.files[0].size < 8388608 ) {
        this.isImageLarge = false
        servicePackageService.uploadImage( formData ).then(res => {
          if(res.responseCode === 0) {
            this.editedItem.image = res.data.img;
            this.editedItem.imgId = res.data.id;
            this.imagePreview = res.data.img;
            if ( this.isNoThumb) {
              this.isNoThumb = false;
            }
            _alert(res, this.$t('SERVICE.UPDATE_IMAGE_SUCCESS'), false );
          } else {
            _alert(res, this.$t('SERVICE.UPDATE_IMAGE_FAIL'), false );
            if ( !this.editedItem.image ) {
              this.isNoThumb = true;
            }
          }
        });
      } else {
        this.isImageLarge = true;
      }
    },
    deleteImage() {
      servicePackageService.removeImage( this.editedItem.imgId ).then(res => {
        _alert(res, this.$t(res.data), false );
      });
    },
    copyFirstValue(value) {
      this.daysOfWeek.forEach(e => {
        this.editedItem[e.code] = value;
      });
    },
    clickSelectAllPlans(){
      if ( this.selectAllPlans ) {
        this.listOfRooms.forEach(e=> {
          this.editedItem.plans.push(e.id);
        });
      } else {
        this.editedItem.plans = [];
      }
    }
  },
  filters: {
    moment: function (date) {
      return moment(date).format('DD/MM/YYYY');
    }
  }
};
</script>
<style lang="scss" scoped>

#service-detail {
  .square {
    position: relative;
    flex-basis: 100%;
    box-sizing: border-box;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    &::before {
      content: "";
      display: block;
      padding-top: 100%;
    }
    & .square-content {
      border-radius: 5px;
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
    }
  }
  .day-apply-in-week {
    .v-select__selections {
      input {
        display: none;
      }
    }
  }
  .add-not-apply-date {
    background-color: #cdcdcc;
    padding: 10px;
    border-radius: 5px;
    font-size: 14px;
    // outline: none;
    i {
      font-size: 18px;
    }
  }
  .room-list {
    background-color: #cdcdcc;
    padding: 20px;
    border-radius: 10px;
  }
  .include-tax {
    span{
      font-size: 13px; 
      margin-top: 3px;
      padding-right: 10px;
    }
    .v-input {
      margin-top: 0;
      padding-top: 0;
      display: inline-block;
    }
  }
  span.icon {
    display: block;
    padding-top: 15px;
    width: 100px;
    text-align: center;
  }
  .price-day {
    margin: 5px 5px 0 5px!important;
  }
  .label-price {
    display: inline-block;
    float: left;
    font-size: 14px;
    padding-right: 10px;
    padding-top: 3px;
  }
  .vue-daterange-picker {
    width: 100%;
  }
  .btn-popup-special-days-price, .add-not-apply-date {
    background-color: #173d8f;
    color: #fff;
    i {
      color: #fff!important;
      font-size: 18px;
    }
    &:focus {
      outline: none;
      box-shadow: none;
    }
  }
  .special-service-desc {
    padding-left: 10px;
    color: red;
  }
}

.table-special-days-price .border-error#date-picker .v-input input {
  border-color: red;
}

</style>